import { useFormContext } from "react-hook-form"
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form"
import InputCpfCnpj from "@/components/ui/input-cpf-cnpj"
import { RequiredMark } from "./required-mark"

interface FormCpfCnpjFieldProps {
  name: string
  label: string
  placeholder?: string,
  required?: boolean
  className?: string,
  disabled?: boolean
}

export function FormCpfCnpjField({
  name,
  label,
  required,
  className,
  placeholder,
  disabled,
}: FormCpfCnpjFieldProps) {
  const { control } = useFormContext()

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <FormLabel className="text-gray-200 text-sm font-semibold">
            {label}
            {required && <RequiredMark />}
          </FormLabel>
          
          <FormControl>
            <InputCpfCnpj field={field} placeholder={placeholder} disabled={disabled} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}